// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./vendor/astrolabe-schematics"

import { Application } from "@hotwired/stimulus"

document.documentElement.classList.add("js")

const application = Application.start()

import FlashController from "./controllers/flash_controller"
import EvidenceDrawerController from "./controllers/evidence_drawer_controller"
import ToastController from "./controllers/toast_controller"
import ClipboardController from "./controllers/clipboard_controller"
import IndustryOtherController from "./controllers/industry_other_controller"
import DropzoneController from "./controllers/dropzone_controller"
import ToggleController from "./controllers/toggle_controller"
import SettingsTabsController from "./controllers/settings_tabs_controller"
import InlineConfirmController from "./controllers/inline_confirm_controller"
import ListgenDrawerController from "./controllers/listgen_drawer_controller"
import ListgenTimerController from "./controllers/listgen_timer_controller"
import ListgenRetryController from "./controllers/listgen_retry_controller"
import ListgenHistoryRowController from "./controllers/listgen_history_row_controller"
// UploadsDrawerController removed — consolidated into SlidePanelController
import BudgetCalculatorController from "./controllers/budget_calculator_controller"
import SeriesTabsController from "./controllers/series_tabs_controller"
import SeriesSelectionController from "./controllers/series_selection_controller"
import SeriesTypeController from "./controllers/series_type_controller"
import SeriesUploadController from "./controllers/series_upload_controller"
import CampaignStatusController from "./controllers/campaign_status_controller"
import ColumnMappingController from "./controllers/column_mapping_controller"
import SeriesStrategyPickerController from "./controllers/series_strategy_picker_controller"
import RetentionToggleController from "./controllers/retention_toggle_controller"
import ScrollRevealController from "./controllers/scroll_reveal_controller"
import MobileMenuController from "./controllers/mobile_menu_controller"
import PricingToggleController from "./controllers/pricing_toggle_controller"
import SectionRatingController from "./controllers/section_rating_controller"
import SlidePanelController from "./controllers/slide_panel_controller"
import NameColumnToggleController from "./controllers/name_column_toggle_controller"
import PlatformDropdownController from "./controllers/platform_dropdown_controller"
import ImportGuideController from "./controllers/import_guide_controller"
import DemoModalController from "./controllers/demo_modal_controller"
// Action Tracker controllers are temporarily retired while the app focuses on
// enrichment, list generation, personas, and generated ideas.
// import ActionTrackerController from "./controllers/action_tracker_controller"
// import ActionTrackerDrawerController from "./controllers/action_tracker_drawer_controller"
import InlineEditController from "./controllers/inline_edit_controller"
import DisclosureController from "./controllers/disclosure_controller"
import AdminTabsController from "./controllers/admin_tabs_controller"
import AstralModalController from "./controllers/astral_modal_controller"
import TutorialController from "./controllers/tutorial_controller"
import UploadParsingController from "./controllers/upload_parsing_controller"
import LeadGenerationChannelsController from "./controllers/lead_generation_channels_controller"
import LeadGenerationAdjustmentController from "./controllers/lead_generation_adjustment_controller"
import LeadGenerationBuilderController from "./controllers/lead_generation_builder_controller"
import LeadPurchaseQuantityController from "./controllers/lead_purchase_quantity_controller"
import AutoGrowTextareaController from "./controllers/auto_grow_textarea_controller"
import DitherController from "./controllers/dither_controller"
import AssemblyDitherController from "./controllers/assembly_dither_controller"
import HeroRippleController from "./controllers/hero_ripple_controller"
import FirstLightController from "./controllers/first_light_controller"
import StarChartParallaxController from "./controllers/star_chart_parallax_controller"
import CountUpController from "./controllers/count_up_controller"

application.register("flash", FlashController)
application.register("evidence-drawer", EvidenceDrawerController)
application.register("toast", ToastController)
application.register("clipboard", ClipboardController)
application.register("industry-other", IndustryOtherController)
application.register("dropzone", DropzoneController)
application.register("toggle", ToggleController)
application.register("settings-tabs", SettingsTabsController)
application.register("inline-confirm", InlineConfirmController)
application.register("listgen-drawer", ListgenDrawerController)
application.register("listgen-timer", ListgenTimerController)
application.register("listgen-retry", ListgenRetryController)
application.register("listgen-history-row", ListgenHistoryRowController)
// uploads-drawer registration removed — consolidated into slide-panel
application.register("budget-calculator", BudgetCalculatorController)
application.register("series-tabs", SeriesTabsController)
application.register("series-selection", SeriesSelectionController)
application.register("series-type", SeriesTypeController)
application.register("series-upload", SeriesUploadController)
application.register("campaign-status", CampaignStatusController)
application.register("column-mapping", ColumnMappingController)
application.register("series-strategy-picker", SeriesStrategyPickerController)
application.register("retention-toggle", RetentionToggleController)
application.register("scroll-reveal", ScrollRevealController)
application.register("mobile-menu", MobileMenuController)
application.register("pricing-toggle", PricingToggleController)
application.register("section-rating", SectionRatingController)
application.register("slide-panel", SlidePanelController)
application.register("name-column-toggle", NameColumnToggleController)
application.register("platform-dropdown", PlatformDropdownController)
application.register("import-guide", ImportGuideController)
application.register("demo-modal", DemoModalController)
// application.register("action-tracker", ActionTrackerController)
// application.register("action-tracker-drawer", ActionTrackerDrawerController)
application.register("inline-edit", InlineEditController)
application.register("disclosure", DisclosureController)
application.register("admin-tabs", AdminTabsController)
application.register("astral-modal", AstralModalController)
application.register("tutorial", TutorialController)
application.register("upload-parsing", UploadParsingController)
application.register("lead-generation-channels", LeadGenerationChannelsController)
application.register("lead-generation-adjustment", LeadGenerationAdjustmentController)
application.register("lead-generation-builder", LeadGenerationBuilderController)
application.register("lead-purchase-quantity", LeadPurchaseQuantityController)
application.register("auto-grow-textarea", AutoGrowTextareaController)
application.register("dither", DitherController)
application.register("assembly-dither", AssemblyDitherController)
application.register("hero-ripple", HeroRippleController)
application.register("first-light", FirstLightController)
application.register("star-chart-parallax", StarChartParallaxController)
application.register("count-up", CountUpController)

// Close slide panels before Turbo navigation to prevent flash on revisit
document.addEventListener("turbo:before-visit", () => {
  document.querySelectorAll("[data-slide-panel-target='panel']").forEach(el => {
    el.classList.add("translate-x-full")
  })
  document.querySelectorAll("[data-slide-panel-target='backdrop']").forEach(el => {
    el.classList.add("hidden")
  })
  document.body.classList.remove("overflow-hidden")
})
